<div
    class="position-absolute"
    data-testid='table-element'
    [style.top.px]="tableViewModel.coordinates.y | scale : yScale"
    [style.left.px]="tableViewModel.coordinates.x | scale : xScale"
    [style.width.px]="tableViewModel.dimensions.width | scale : xScale"
    [style.height.px]="tableViewModel.dimensions.height | scale : yScale"
>
    <div class="h-100 w-100 position-relative">
        <ng-container *ngIf="shapeClass === 'round-table' && roundTableChairs.length > 0">
            <div 
                *ngFor="let chair of roundTableChairs; let i = index" 
                class="chair chair-radial"
                [style.left.%]="chair.x"
                [style.top.%]="chair.y"
                [style.transform]="'translate(-50%, -50%) rotate(' + chair.angle + 'deg)'"
            ></div>
        </ng-container>
        
        <div class="chairs chairs-top" *ngIf="shapeClass !== 'round-table' && chairSides.top > 0">
            <div *ngFor="let _ of chairArrayPerSide.top; let i = index" class="chair chair-top"></div>
        </div>
        <div class="chairs chairs-bottom" *ngIf="shapeClass !== 'round-table' && chairSides.bottom > 0">
            <div *ngFor="let _ of chairArrayPerSide.bottom; let i = index" class="chair chair-bottom"></div>
        </div>
        <div class="chairs chairs-left" *ngIf="shapeClass !== 'round-table' && chairSides.left > 0">
            <div *ngFor="let _ of chairArrayPerSide.left; let i = index" class="chair chair-left"></div>
        </div>
        <div class="chairs chairs-right" *ngIf="shapeClass !== 'round-table' && chairSides.right > 0">
            <div *ngFor="let _ of chairArrayPerSide.right; let i = index" class="chair chair-right"></div>
        </div>
        <div
            class="floor-table vstack gap-1 p-1 align-items-center justify-content-center h-100 w-100"
            [ngClass]="[bookedStatus, shapeClass, editModeClass]"
            [style.border-radius]="shapeClass === 'round-table' ? roundTableBorderRadius : null"
            [ngbTooltip]="calendarBookingTooltipViewModel ? bookingTooltipTemplate : null"
            [disableTooltip]="bookingTooltipDisabled || !calendarBookingTooltipViewModel"
            container="body"
            tooltipClass="booking-tooltip"
            placement="top"
            [style.--booking-progress]="bookingProgress"
            (mouseenter)="onMouseEnterTable()"
            (mouseleave)="onMouseLeaveTable()"
        >
            <app-service-status-badge
                *ngIf="activeServiceStatus !== null"
                class="service-status-overlay position-absolute"
                [serviceStatus]="activeServiceStatus"
                variant="icon"
            >
            </app-service-status-badge>
            <div class="table-name text-center">
                {{ tableViewModel.table.shortFormattedDisplayName }}
            </div>
            <div class="hstack gap-1 justify-content-center">
                <img class="icon-xs" src="assets/people/normal.svg" />
                <span class="covers">
                    {{ tableViewModel.table.minimumSeats }} - {{ tableViewModel.table.maximumSeats }}
                </span>
            </div>
            <div
                *ngIf="!tableViewModel.isBooked && !tableViewModel.isSeated && tableViewModel.formattedNextBookedStarts && tableViewModel.formattedNextBookedStarts.length > 0"
                class="d-flex flex-column gap-1 w-100 align-items-center"
            >
                <span
                    class="upcoming-time badge rounded bg-body-tertiary text-body border border-dark fw-semibold"
                >
                    {{ tableViewModel.formattedNextBookedStarts[0] }}
                </span>
            </div>
        </div>
        <ng-template #bookingTooltipTemplate>
            <app-booking-tooltip
                *ngIf="calendarBookingTooltipViewModel"
                [viewModel]="calendarBookingTooltipViewModel"
            ></app-booking-tooltip>
        </ng-template>
        @if (tableViewModel.canUpdateCoordinates) {
            <div class="edge-highlight top" [class.active]="activeEdges?.top"></div>
            <div class="edge-highlight right" [class.active]="activeEdges?.right"></div>
            <div class="edge-highlight bottom" [class.active]="activeEdges?.bottom"></div>
            <div class="edge-highlight left" [class.active]="activeEdges?.left"></div>
            <div class="resize-handle top-left" [class.active]="activeEdges?.top && activeEdges?.left"></div>
            <div class="resize-handle top" [class.active]="activeEdges?.top && !activeEdges?.left && !activeEdges?.right"></div>
            <div class="resize-handle top-right" [class.active]="activeEdges?.top && activeEdges?.right"></div>
            <div class="resize-handle right" [class.active]="activeEdges?.right && !activeEdges?.top && !activeEdges?.bottom"></div>
            <div class="resize-handle bottom-right" [class.active]="activeEdges?.bottom && activeEdges?.right"></div>
            <div class="resize-handle bottom" [class.active]="activeEdges?.bottom && !activeEdges?.left && !activeEdges?.right"></div>
            <div class="resize-handle bottom-left" [class.active]="activeEdges?.bottom && activeEdges?.left"></div>
            <div class="resize-handle left" [class.active]="activeEdges?.left && !activeEdges?.top && !activeEdges?.bottom"></div>
        }
    </div>
</div>
